const sendToGA = (data) => {
  dataLayer.push(data);
};

// Only sends data to GA if it's not a duplicate of another recent event
// E.g: Repeated identical search queries from algolia inputs
const sendNonRepeatToGA = (data) => {
  // Get a copy of the source data's most recent same event & remove the id
  const lastOfEvent = dataLayer?.slice().reverse().find((i) => i.event === data.event);
  if (!lastOfEvent) {
    sendToGA(data); // No past event, first is always unique
    return;
  }
  delete lastOfEvent['gtm.uniqueEventId'];

  if (_.isEqual(lastOfEvent, data) === false) sendToGA(data);
};

export {
  sendToGA,
  sendNonRepeatToGA
};
